import { useMemo } from "react"
import { Box } from "@chakra-ui/react"

import { useFetchMats } from "#/shared/hooks"

import StackMatsnetBtcForm from "./StackMatsnetBtcForm"
import StackMatsnetBtcModalHeader from "./StackMatsnetBtcModalHeader"

type StackMatsnetBtcModalBaseProps = {
  onSuccessCallback?: (stackedSats?: string, address?: string) => void
}

export default function StackMatsnetBtcModalBase({
  onSuccessCallback,
}: StackMatsnetBtcModalBaseProps) {
  const { data: mats } = useFetchMats()

  const totalMats = useMemo(() => mats?.totalMats ?? 0, [mats?.totalMats])

  return (
    <Box bg="primary.white.100" borderRadius="1.5rem" w="522px">
      <StackMatsnetBtcModalHeader totalMats={totalMats} />
      <Box px="55px" py="32px">
        <StackMatsnetBtcForm
          totalMats={totalMats}
          onSuccessCallback={onSuccessCallback}
        />
      </Box>
    </Box>
  )
}
